import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Card } from 'primeng/card';

@Component({
  selector: 'bn-brightnav-admin-dev',
  imports: [Card, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section
      class="flex max-w-3xl flex-col gap-4"
      aria-labelledby="admin-dev-title"
    >
      <h2
        id="admin-dev-title"
        class="m-0 text-base font-semibold text-surface-900"
      >
        Dev
      </h2>
      <a
        class="block rounded-xl no-underline text-inherit focus-visible:ring-2 focus-visible:ring-primary"
        routerLink="/brightnav/admin/dev/sentry-logs"
        aria-label="Open Sentry log tests"
      >
        <p-card>
          <h3 class="m-0 mb-2 text-base font-semibold text-surface-900">
            Sentry log tests
          </h3>
          <p class="m-0 text-sm text-surface-600">
            Generate marked failure and recovery logs without changing client
            records.
          </p>
        </p-card>
      </a>
    </section>
  `,
})
export class BrightnavAdminDevComponent {}
